/* The industry a workspace picks during setup. Ids are fixed values shared with
 * the rest of our sites and validated by the API against
 * `Organization::INDUSTRIES` — never renumber them, existing rows point here.
 *
 * Which starter templates belong to which industry is decided on the server:
 * a new organization is given its own copy of the matching templates when it is
 * created, so the panel only ever lists templates that already fit. Keeping a
 * second copy of that mapping here would be a second thing to update. */
export const INDUSTRY_OPTIONS = [
  { value: 20, label: "بیمه" },
  { value: 21, label: "نفت و گاز" },
  { value: 1, label: "کامپیوتر، فناوری اطلاعات و اینترنت" },
  { value: 22, label: "نیرو" },
  { value: 25, label: "منابع انسانی" },
  { value: 11, label: "رسانه و انتشارات" },
  { value: 14, label: "تبلیغات، بازاریابی و برندسازی" },
  { value: 12, label: "مخابرات و ارتباطات (تلکام)" },
  { value: 5, label: "آموزش، مدارس و دانشگاه‌ها" },
  { value: 6, label: "معماری و عمران" },
  { value: 8, label: "تولید و صنایع" },
  { value: 23, label: "املاک و مستغلات" },
  { value: 7, label: "دولتی" },
  { value: 3, label: "مالی و اعتباری" },
  { value: 9, label: "خدمات درمانی، پزشکی و سلامت" },
  { value: 27, label: "گردشگری و هتل‌ها" },
  { value: 4, label: "وکالت و حقوقی" },
  { value: 30, label: "استاندارد و کنترل‌کیفیت" },
  { value: 17, label: "بانکداری" },
  { value: 26, label: "حمل و نقل، لاجستیک و انبارداری" },
  { value: 24, label: "خرده‌فروشی، عمده‌فروشی و فروشگاه‌های زنجیره‌ای" },
  { value: 16, label: "خودروسازی" },
  { value: 28, label: "سازمان‌های مردم‌نهاد (NGO)" },
  { value: 19, label: "سرمایه‌گذاری و تحلیل کسب‌وکار" },
  { value: 13, label: "غذا و رستوران‌ها" },
  { value: 31, label: "فرهنگی و ورزشی" },
  { value: 18, label: "کالای مصرفی و خوراکی" },
  { value: 15, label: "کشاورزی" },
  { value: 29, label: "واردات و صادرات" },
];

export const industryLabel = (value) =>
  INDUSTRY_OPTIONS.find((item) => item.value === value)?.label || null;
